import { Link } from "react-router-dom";
import { Briefcase, Mail, MapPin } from "lucide-react";

export default function CareersPage() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-8 py-12 lg:py-16" data-testid="careers-page">
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#B45309]">Careers</p>
      <h1 className="font-serif text-3xl sm:text-4xl font-bold text-stone-900 mt-3 tracking-tight">Work with Customize Gift Online</h1>
      <p className="text-stone-500 mt-3 max-w-xl leading-relaxed">
        We're a small team that loves making people smile for a living — printers, designers, packers and problem-solvers.
      </p>

      <div className="mt-10 p-8 rounded-3xl bg-white border border-[#E9E2D7] text-center" data-testid="careers-openings">
        <span className="w-14 h-14 mx-auto rounded-2xl bg-[#F5EFE6] grid place-items-center"><Briefcase size={24} className="text-[#B45309]" /></span>
        <h2 className="font-serif text-2xl font-bold text-stone-900 mt-5">No open roles right now</h2>
        <p className="text-stone-500 mt-2 max-w-md mx-auto text-sm leading-relaxed">
          We don't have any openings at the moment, but we grow fast around the festive season.
          Check back later — or send us your resume and we'll reach out when something fits.
        </p>
        <a
          href="mailto:customizegiftonline@gmail.com?subject=Resume%20—%20Careers%20at%20Customize%20Gift%20Online"
          className="inline-flex items-center gap-2 mt-6 px-7 h-12 rounded-full bg-[#B45309] text-white text-sm font-bold hover:bg-[#92400E] transition-colors"
          data-testid="careers-resume-cta"
        >
          <Mail size={15} /> Email your resume
        </a>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-6">
        <div className="p-5 rounded-2xl bg-[#F9F3EA] border border-[#E9E2D7]">
          <Mail size={18} className="text-[#B45309]" />
          <p className="font-bold text-stone-800 text-sm mt-2.5">Write to us</p>
          <p className="text-sm text-stone-500 mt-1">customizegiftonline@gmail.com · 9899534126</p>
        </div>
        <div className="p-5 rounded-2xl bg-[#F9F3EA] border border-[#E9E2D7]">
          <MapPin size={18} className="text-[#B45309]" />
          <p className="font-bold text-stone-800 text-sm mt-2.5">Where we work</p>
          <p className="text-sm text-stone-500 mt-1">Remote-first, shipping across India</p>
        </div>
      </div>

      <p className="text-center text-sm text-stone-400 mt-10">
        Looking for gifts instead? <Link to="/shop" className="font-bold text-[#B45309] hover:underline" data-testid="careers-shop-link">Browse the collection →</Link>
      </p>
    </div>
  );
}
